import { lazy } from 'react';

const ConfirmDeleteIndicatorType = lazy(
  () =>
    import(
      'modules/AccountabilitySystemSetup/modals/ConfirmDeleteIndicatorType'
    ),
);
const IndicatorConfigurationPlanScopeModal = lazy(
  () => import('modules/AccountabilitySystemSetup/modals/ChoosePlanScopeModal'),
);
const ChooseNewIndicatorTypeModal = lazy(
  () =>
    import(
      'modules/AccountabilitySystemSetup/modals/ChooseNewIndicatorTypeModal'
    ),
);
const LockedConfiguration = lazy(
  () => import('modules/AccountabilitySystemSetup/modals/LockedConfiguration'),
);
const IndicatorStartFuturePlanModal = lazy(
  () => import('modules/AccountabilitySystemSetup/modals/StartFuturePlanModal'),
);
const IndicatorStartFuturePlanModalV2 = lazy(
  () => import('modules/AccountabilitySystemSetup/modals/StartFuturePlanModal'),
);

export default {
  CHOOSE_NEW_INDICATOR_TYPE_MODAL: ChooseNewIndicatorTypeModal,
  CONFIRM_DELETE_INDICATOR_TYPE: ConfirmDeleteIndicatorType,
  INDICATOR_CONFIGURATION_PLAN_SCOPE_MODAL:
    IndicatorConfigurationPlanScopeModal,
  INDICATOR_START_FUTURE_PLAN_MODAL: IndicatorStartFuturePlanModal,
  INDICATOR_START_FUTURE_PLAN_MODAL_V2: IndicatorStartFuturePlanModalV2,
  LOCKED_CONFIGURATION: LockedConfiguration,
};
